<script>
export default {
  data() {
    return {
      isOpenForm: false,
      selected: null,
      active: true,

      options0: [
        { text: 'Select', value: null },
        { text: 'Mr.', value: 'Mr.' },
        { text: 'Miss', value: 'Miss.' },
        { text: 'Mrs.', value: 'Mrs.' },
      ],

      options2: [
        { text: 'Select', value: null },
        { text: 'Jr.', value: 'Jr.' },
        { text: 'Sr.', value: 'Sr.' },
        { text: 'I', value: 'I' },
        { text: 'II', value: 'II' },
        { text: 'III', value: 'III' },
      ],
      options1: [
        { text: 'Select', value: null },
        { text: 'Credit Plus Super Admin', value: 'CreditPlusSuperAdmin' },
        { text: 'Credit Plus Admin', value: 'CreditPlusAdmin' },
        { text: 'Credit Plus Executive', value: 'CreditPlusExecutive' },
        {
          text: 'Credit Plus Pre-qual Admin',
          value: 'CreditPlusPre-qualAdmin',
        },
      ],
    }
  },
  methods: {
    toggleEventParent: function() {
      this.active = false
    },
  },
}
</script>

<template>
  <div class="mt-1 container bg-white p-4">
    <b-form @submit.stop.prevent>
      <BaseELabel size="md" label="Official Details" />
      <b-row>
        <b-col md="2">
          <BaseELabel label="Salutation" />
          <BaseDropdown
            id="text-salutation"
            v-model="selected"
            type="text"
            :options="options0"
          ></BaseDropdown>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="text-firstname"
            type="text"
            label-content="First Name"
          ></BaseEInputText>
        </b-col>
        <b-col md="2">
          <BaseEInputText
            id="text-middle"
            type="text"
            label-content="Middle Initial"
          ></BaseEInputText>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="text-lastname"
            type="text"
            label-content="Last Name"
          ></BaseEInputText>
        </b-col>
        <b-col md="2">
          <BaseELabel label="Suffix" />
          <BaseDropdown
            id="text-suffix"
            v-model="selected"
            type="text"
            :options="options2"
          ></BaseDropdown>
        </b-col>
      </b-row>
      <BaseELabel label="Official Details" />
      <b-row>
        <b-col md="6">
          <BaseEInputText
            id="text-email"
            type="text"
            label-content="Email ID"
          ></BaseEInputText>
        </b-col>
        <b-col md="6">
          <BaseEInputText
            id="text-mobile"
            type="text"
            label-content="Mobile Number"
          ></BaseEInputText>
        </b-col>
        <b-col md="6">
          <BaseELabel label="Role" />
          <BaseDropdown
            id="text-role"
            type="text"
            :options="options1"
          ></BaseDropdown>
        </b-col>
        <b-col md="6">
          <BaseELabel label="Status" />
          <BaseSwitch @toggleEvent="toggleEventParent" />
          <span v-if="active">Active</span>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col md="2">
          <BaseEButton variant="cancel">CANCEL</BaseEButton>
        </b-col>
        <b-col md="2">
          <BaseEButton>UPDATE</BaseEButton>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.labelHeader p {
  font-size: $size-content-font-sm;
  color: $color-text;
}
</style>
